<template>
  <div>
    <v-app>
      <new-toolbar></new-toolbar>
      <div v-if="!$store.getters.getMobilePhoneActive">
        <v-container v-resize="onResize" v-if="$store.getters.getNoBackground">
          <router-view class="mt-5"/>
        </v-container>
        <v-container v-else :style="backgroundStyleRecieved">
          <router-view class="mt-5"/>
        </v-container>
      </div>
      <div v-else>
        <v-container-mobile v-resize="onResize" v-if="$store.getters.getNoBackground">
          <router-view class="mt-5"/>
        </v-container-mobile>
        <v-container-mobile v-else :style="backgroundStyleRecieved">
          <router-view class="mt-5"/>
        </v-container-mobile>
      </div>
      <cp-footer></cp-footer>
    </v-app>
  </div>
</template>

<script>
import NewToolbar from "./NewToolbar";
import CpFooter from "./CpFooter";
import { store } from "../store.js";
import { mapGetters } from "vuex";
import { ui_helpers } from "@/shared/ui_helpers";

export default {
  name: 'CustomerPage',
  components: {
    NewToolbar,
    CpFooter
  },
  mixins: [ui_helpers],

  data() {
    return {
     backgroundStyleRecieved: ""
    }
  },
  mounted() {
     setTimeout(() => {
             this.backgroundStyleRecieved = this.backgroundStyle;
          }, 400);

  },
  methods: {
        onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
      this.carouselHeight = 8.1 * window.innerHeight;
    }
  }
};
</script>
<style lang="scss" scoped>
/*  -webkit-animation: slide 20s linear infinite; */
@-webkit-keyframes slide {
  from {
    background-position: 0 0;
  }
  to {
    background-position: -400px 0;
  }
}

</style>
